import { ItemData } from "../../_helpers/list-selector/list-selector-item/list-selector-item";

export type ObjectData = {
  id: string;
  icon: string;
  name: string;
};

export const objectsToListItemData = (objects: ObjectData[]): ItemData[] => {
  const itemsData: ItemData[] = [];
  objects.forEach(object => {
    const itemId = object.id;
    const itemValue = object.name;
    const itemIcon: string = object.icon;
    const itemChecked: boolean = false;
    itemsData.push({
      itemId: itemId,
      itemValue: itemValue,
      itemIcon: itemIcon,
      itemChecked: itemChecked
    });
  });
  return itemsData;
};
